export const tableSelectConfig = {
    services: {
        //Auswahl zu Leistungen
        service: [
            //Diese Auswahl nur bei personenbezogener und nichtpersonenbezogener Leistungserfassung einblenden
            {
                id: 1,
                value: "Information"
            },
            //Diese Auswahl nur bei personenbezogener und nichtpersonenbezogener Leistungserfassung einblenden
            {
                id: 2,
                value: "Beratung"
            },
            //Diese Auswahl nur bei personenbezogener Leistungserfassung einblenden
            {
                id: 3,
                value: "Vermittlung an Wohnbetreuung"
            },
            //Diese Auswahl nur bei personenbezogener Leistungserfassung einblenden
            {
                id: 4,
                value: "Vermittlung an Fachkräfte bzw. Fachstellen"
            },
            //Diese Auswahl nur bei personenbezogener Leistungserfassung einblenden
            {
                id: 5,
                value: "Vermittlung an Selbsthilfegruppen / Ehrenamtliche Initiativen"
            },
            //Diese Auswahl nur bei personenbezogener Leistungserfassung einblenden
            {
                id: 6,
                value: "Haus- und Krankenbesuche"
            },
            //Diese Auswahl nur bei personenbezogener Leistungserfassung einblenden
            {
                id: 7,
                value: "Beleitung zu Ämtern, Arztpraxen, Einkäufen"
            },
            //Diese Auswahl nur bei personenbezogener Leistungserfassung einblenden
            {
                id: 8,
                value: "Hilfe zur Kommunikation"
            },
            //Diese Auswahl nur bei personenbezogener Leistungserfassung einblenden
            {
                id: 9,
                value: "Vermittlung an andere"
            },
            {
                id: 10,
                value: "Sonstige Leistungen"
            }
        ],

        //Tabelle Leistungen
        //Auswahl zu Differenzierung der Leistungen Beratung und Information
        differentiationConsultation: [
            {
                id: 1,
                value: "Keine Angabe"
            },
            {
                id: 2,
                value: "Persönlich im Büro"
            },
            {
                id: 3,
                value: "Persönlich vor Ort"
            },

            {
                id: 4,
                value: "Schriftlich / auch Internet / Mail"
            },

            {
                id: 5,
                value: "Per Video"
            },
            {
                id: 6,
                value: "Telefonisch"
            }
        ],

        //Tabelle Leistungen
        //Auswahl zu Beratungsaufwand
        effortConsultation: [
            {
                id: 1,
                value: "Keine Angabe"
            },
            {
                id: 2,
                value: "Bis 30 Minuten"
            },
            {
                id: 3,
                value: "Bis 90 Minuten"
            },

            {
                id: 4,
                value: "Bis 180 Minuten"
            },

            {
                id: 5,
                value: "Mehr als 180 Minuten"
            }
        ],

        //Tabelle Leistungen
        //Auswahl zu Leistung an
        serviceFor: [
            {
                id: 1,
                value: "Keine Angabe"
            },
            {
                id: 2,
                value: "Mensch mit Behinderung (im direkten Kontakt)"
            },
            {
                id: 3,
                value: "Familie, rechtl. Betreuer*innen etc."
            },
            {
                id: 4,
                value: "Fachkräfte und Fachstellen"
            },
            {
                id: 5,
                value: "Selbsthilfegruppen"
            },

            {
                id: 6,
                value: "Ehrenamtliche Helfer*innen"
            },

            {
                id: 7,
                value: "Versorgungseinrichtungen"
            },
            {
                id: 8,
                value: "Persönliche Arbeitsassistenz"
            },
            {
                id: 9,
                value: "Sonstige"
            }
        ]
    }
}

export const selectConfigUserData = {
    gender: [
        {
            id: 1,
            value: "Keine Angabe"
        },
        {
            id: 2,
            value: "Männlich"
        },
        {
            id: 3,
            value: "Weiblich"
        },
        {
            id: 4,
            value: "Divers"
        }
    ],

    motherTongue: [
        {
            id: 1,
            value: "Keine Angabe"
        },
        {
            id: 2,
            value: "Deutsch"
        },
        {
            id: 3,
            value: "Andere"
        }
    ],
    nationality: [
        {
            id: 1,
            value: "Keine Angabe"
        },
        {
            id: 2,
            value: "Deutsch"
        },
        {
            id: 3,
            value: "Europäische Union"
        },
        {
            id: 4,
            value: "Europäisches Land außerhalb der EU"
        },
        {
            id: 5,
            value: "Sonstige"
        },
        {
            id: 6,
            value: "Staatenlos"
        }
    ],
    employment: [
        {
            id: 1,
            value: "Keine Angabe"
        },
        {
            id: 2,
            value: "Ja"
        },
        {
            id: 3,
            value: "Nein"
        }
    ],
    priorityDisability: [
        {
            id: 1,
            value: "Keine Angabe"
        },
        {
            id: 2,
            value: "Geistige Behinderung"
        },
        {
            id: 3,
            value: "Körperliche Behinderung"
        },
        {
            id: 4,
            value: "Sinnesbehinderung"
        },
        {
            id: 5,
            value: "Seelische Behinderung"
        },
        {
            id: 6,
            value: "Autismus"
        }
    ],
    typeOfHousing: [
        {
            id: 1,
            value: "Keine Angabe"
        },
        {
            id: 2,
            value: "Eigene Wohnung"
        },
        {
            id: 3,
            value: "Familie / Angehörige"
        },
        {
            id: 4,
            value: "Besondere Wohnformen gem. SGB IX"
        },
        {
            id: 5,
            value: "Wohngemeinschaft"
        },
        {
            id: 6,
            value: "Stationäre Pflegeeinrichtung gem. SGB XI"
        },
        {
            id: 7,
            value: "Keine Meldeadresse"
        },
        {
            id: 8,
            value: "Andere Wohnformen"
        }
    ],
    typeOfCare: [
        {
            id: 1,
            value: "Keine Angabe"
        },
        {
            id: 2,
            value: "Familie/Angehörige"
        },
        {
            id: 3,
            value: "Leistungen der EGH"
        },
        {
            id: 4,
            value: "Einzelfallhilfe / Persönliche Assistenz"
        },
        {
            id: 5,
            value: "Assistenzleistungen in eigener Wohnung (Leistung der EGH)"
        },
        {
            id: 6,
            value: "Wohngemeinschaft (LT1-3)"
        },
        {
            id: 7,
            value: "Stationäre Unterstützungsform"
        },
        {
            id: 8,
            value: "Jugendhilfe"
        },
        {
            id: 9,
            value: "Wohnungslosenhilfe"
        },
        {
            id: 10,
            value: "Klinik"
        },
        {
            id: 11,
            value: "Pflege / Hilfe zur Pflege"
        },
        {
            id: 12,
            value: "Verschiedene Lebensformen / Andere Unterstützungsformen"
        },
        {
            id: 13,
            value: "Keine Unterstützungs- / Assistenzleistungen"
        }
    ],
    arrangedBy: [
        {
            id: 1,
            value: "Keine Angabe"
        },
        {
            id: 2,
            value: "Selbstmelder*in"
        },
        {
            id: 3,
            value: "Familiäres / privates Umfeld"
        },
        {
            id: 4,
            value: "Einzelfallhelfer*in"
        },
        {
            id: 5,
            value: "Rechtliche Vertreter*in"
        },
        {
            id: 6,
            value: "Bezirksämter"
        },
        {
            id: 7,
            value: "Eingliederungshilfe (EGH)"
        },
        {
            id: 8,
            value: "Jugendhilfe"
        },
        {
            id: 9,
            value: "Pflege"
        },
        {
            id: 10,
            value: "Klinik"
        },
        {
            id: 11,
            value: "Wohnungslosenhilfe"
        },
        {
            id: 12,
            value: "Andere"
        }
    ]
}